<template>
  <div class="egl-elm egl-detail setting clearfix">
    <el-form-item :label="$locale('setting.cinema.websiteCode')" prop="cinemaSetting.websiteCode">
      <el-input :placeholder="$locale('setting.cinema.p.minutes')" v-model="detailObj.cinemaSetting.websiteCode" :disabled="!editable" maxlength="255"></el-input>
    </el-form-item>
  </div>
</template>

<script>

export default {
  name: "cinemaJointSetting",
  props: {
    detailObj: Object,
  },
  data() {
    return {
      editable: true,
      action: "create",
      formRules: {

      },
    };
  },
  methods: {},
};
</script>
